import YandexMetrika from "./yandexMetrika";
import {listener, onReady} from "../../functions";

listener('click', '[data-yagoal]', (el, e) => {
	String(el.dataset.yagoal).split(',').forEach(goal => {
		new YandexMetrika().goal(goal);
	});
});

listener('vg.fs.success', '[data-yagoal-form]', (el, e) => {
	String(el.dataset.yagoalForm).split(',').forEach(goal => {
		console.log('goal');
		new YandexMetrika().goal(goal);
	});
});

function ready() {
	document.querySelectorAll('[data-yagoal-static]').forEach((el) => {
		new YandexMetrika().goal(el.dataset.yagoalStatic);
	});
}

onReady(ready);
typeof onTurboRender !== 'undefined' && onTurboRender(ready);
